enum Mutation {
  SET_APM_TIMEFRAME = 'setAPMTimeframe',
  SET_CALENDAR_TIMEFRAMES = 'setCalendarTimeframes',
  SET_TIMEFRAME_KIND = 'setTimeframeKind',
  SET_VIEW_KIND = 'setViewKind',
  SET_PRINT_VIEW_KIND = 'setPrintViewKind',
  SET_PRINT_TIMEFRAMES = 'setPrintTimeframes',
  SET_SLOT_DISPLAY_STYLE = 'setSlotDisplayStyle',
  SET_JOB = 'setJob',
  REMOVE_JOB = 'removeJob',
}

export default Mutation;
